const host = window.location.hostname;
// ⚠️ Preview Cloudflare Pages détecté EN PREMIER : un nom de branche peut contenir
// "test"/"staging" (ex. feat/la-test-preview) et fausser la détection d'environnement.
// Sur une preview on utilise les variables d'env (→ staging) et l'origine courante.
const isPreview = host.endsWith(".pages.dev");
const isStaging = !isPreview && host.includes("staging");
const isTest = !isPreview && host.includes("test");

const oidcConfig = {
  authority: isPreview
    ? (process.env.REACT_APP_OIDC_AUTHORITY || "https://auth-staging.luniwave.com/realms/Luniwave/")
    : isTest ? "https://auth-test.luniwave.com/realms/Luniwave/"
    : isStaging ? "https://auth-staging.luniwave.com/realms/Luniwave/"
    : process.env.REACT_APP_OIDC_AUTHORITY || "http://localhost:8080/realms/Luniwave/",
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID || "react-auth",
  redirect_uri: isPreview
    ? `${window.location.origin}/redirect`
    : isTest ? "https://app-test.luniwave.com/redirect"
    : isStaging ? "https://app-staging.luniwave.com/redirect"
    : process.env.REACT_APP_OIDC_REDIRECT_URI || "http://localhost:3000/redirect",
  // Retour post-logout à la racine (comme LuniManager) : la home publique avec
  // « Se connecter », sans passer par /redirect (réservé au callback de login).
  post_logout_redirect_uri: isPreview
    ? window.location.origin
    : isTest ? "https://app-test.luniwave.com"
    : isStaging ? "https://app-staging.luniwave.com"
    : process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI || "http://localhost:3000",
  response_type: "code", // Utilise 'code' pour PKCE
  scope: "openid profile email",
  // Activer PKCE
  usePkce: true,
};

// console.log(isStaging);
// console.log(oidcConfig);

export default oidcConfig;
